import { ChevronLeft, ChevronRight } from "lucide-react";
import { formatMonthLabel, jstMonth, shiftMonth } from "../lib/normalize";

/**
 * 経費履歴などの「対象月」を選択するストリップ。
 * 「‹ 2026年6月 ›」の前後月ボタン方式。未来月へは進めない (過去データのみ対象)。
 */
export function MonthStrip({
  value,
  onChange,
}: {
  /** 選択中の対象月 "YYYY-MM" */
  value: string;
  onChange: (ym: string) => void;
}) {
  const isCurrent = value >= jstMonth();

  return (
    <div className="flex items-center justify-between gap-2 border-b border-[var(--rule-soft)] bg-[var(--bg-raised)] px-3 py-2.5">
      <button
        type="button"
        aria-label="前の月"
        onClick={() => onChange(shiftMonth(value, -1))}
        className="flex h-11 w-11 items-center justify-center rounded-lg text-[var(--ink-2)] hover:bg-[var(--bg-sunken)]"
      >
        <ChevronLeft size={20} />
      </button>

      <div className="flex items-center gap-1.5">
        <span className="num text-[length:var(--fs-md)] font-semibold">
          {formatMonthLabel(value)}
        </span>
        {isCurrent && (
          <span className="rounded-full bg-[var(--st-done-bg)] px-2 py-0.5 text-[length:var(--fs-xs)] font-semibold text-[var(--st-done-ink)]">
            今月
          </span>
        )}
      </div>

      <button
        type="button"
        aria-label="次の月"
        disabled={isCurrent}
        onClick={() => onChange(shiftMonth(value, 1))}
        className="flex h-11 w-11 items-center justify-center rounded-lg text-[var(--ink-2)] hover:bg-[var(--bg-sunken)] disabled:cursor-not-allowed disabled:opacity-30"
      >
        <ChevronRight size={20} />
      </button>
    </div>
  );
}
